import script from "./Trial.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trial.vue?vue&type=script&setup=true&lang=ts"

import "./Trial.vue?vue&type=style&index=0&id=10d349e1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d349e1"]])

export default __exports__